import Instance from "../../../Axios";

const GetPlusPotencias = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/potencias`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_POTENCIAS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusPotencias;
